import { render, staticRenderFns } from "./SectionLicense.vue?vue&type=template&id=1eccb024&"
import script from "./SectionLicense.vue?vue&type=script&lang=js&"
export * from "./SectionLicense.vue?vue&type=script&lang=js&"
import style0 from "./SectionLicense.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports